export const extractErrorMessage = (error) => {
  if (error?.response?.data?.errors) {
    return Object.values(error.response.data.errors).join(" | ");
  }

  return (
    error?.response?.data?.errorBody ||
    error?.message ||
    "An error occurred while updating or retrieving data"
  );
};
